import React, {useCallback} from 'react'
import styled from '@emotion/styled'
import {getAllFilterKeys} from 'components/Filters/utils'
import {emptyFilterState, useFiltersForm} from 'hooks/useFiltersForm'
import {getSapiFiltersFromDaedalusSearchParameters} from 'modules/sapiSearch/utils'

import {Pill} from '@vio/atlas/Pill'
import {cssTheme} from '@vio/atlas/themes'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

const allFilterKeys = getAllFilterKeys()

// The `link` Pill variant was removed in Atlas v2. The "Clear all" pill mirrors
// the "All filters" filter pill (see FilterDisplayContainer): the default Pill
// state is overridden with interactive-primary content and outline colors.
const StyledPill = styled(Pill)`
  outline-color: ${cssTheme.colors.border.interactive.primary}!important;
  color: ${cssTheme.colors.content.interactive.primary}!important;
`

export const ClearAllPill = () => {
  const {trackFilterClick, clearFiltersAndApply, getAppliedFiltersCount} =
    useFiltersForm(allFilterKeys, 'clearAll')

  const count = getAppliedFiltersCount()

  const handleClear = useCallback(() => {
    const newSelectedFilters =
      getSapiFiltersFromDaedalusSearchParameters(emptyFilterState)

    trackFilterClick({
      category: Category.User,
      entity: Entity.FilterPreference,
      action: Action.Submitted,
      payload: {
        newSelectedFilters: newSelectedFilters,
        allSelectedFilters: newSelectedFilters,
        appliedFiltersFrom: 'clearAll'
      }
    })
    clearFiltersAndApply()
  }, [clearFiltersAndApply, trackFilterClick])

  return count > 0 ? (
    <StyledPill onClick={handleClear}>
      <FormattedMessageWrapper id="clearAll" defaultMessage="Clear all" />
    </StyledPill>
  ) : null
}
